import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useRef, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { MenuChipButton } from '../Menu.ChipButton/Menu.ChipButton.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';
import { MenuIconButton } from '../Menu.IconButton/Menu.IconButton.es.js';
import { MenuOptions } from '../Menu.Options/Menu.Options.es.js';

/**
 * Menu V2.
 */ const MenuV2Core = ({ className, disabled, dropDirection = 'down', variant = 'default', children, role, ...rest })=>{
    const [{ open }, { setOpen }] = useMenuContext();
    const menuClasses = classNames('cb-menu', className);
    const containerRef = useRef(null);
    const handleOutsideClick = useCallback((e)=>{
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            setOpen(false);
        }
    }, [
        setOpen
    ]);
    useEffect(()=>{
        document.addEventListener('mousedown', handleOutsideClick);
        return ()=>{
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    const triggerComponent = useMemo(()=>React__default.Children.toArray(children).filter((c)=>/*#__PURE__*/ React__default.isValidElement(c) && (c.type === MenuIconButton || c.type === MenuChipButton)), [
        children
    ]);
    const optionsComponent = useMemo(()=>React__default.Children.toArray(children).filter((c)=>/*#__PURE__*/ React__default.isValidElement(c) && c.type === MenuOptions), [
        children
    ]);
    return jsxs("div", {
        className: menuClasses,
        "data-testid": "menu-container",
        ...rest,
        ref: containerRef,
        children: [
            triggerComponent,
            jsx("div", {
                className: classNames('options-container', dropDirection, `variant-${variant}`, {
                    open
                }),
                "data-testid": "options-container",
                children: optionsComponent
            })
        ]
    });
};

export { MenuV2Core };
//# sourceMappingURL=Menu.Core.es.js.map
